import React, { useState, useEffect } from "react"; // Import useEffect
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";

const SSOLogin = ({ setUserRole }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Add useEffect for cleanup on mount
  useEffect(() => {
    // Find and remove any existing reCAPTCHA script tags
    const scripts = document.head.getElementsByTagName("script");
    for (let i = scripts.length - 1; i >= 0; i--) {
      if (scripts[i].src.includes("recaptcha/api.js")) {
        scripts[i].parentNode.removeChild(scripts[i]);
        break;
      }
    }

    // Remove the reCAPTCHA badge element if it exists
    const badge = document.querySelector('.grecaptcha-badge');
    if (badge) {
      badge.parentNode.removeChild(badge);
    }

    // Explicitly undefine the global grecaptcha object if it exists
    if (window.grecaptcha) {
      try {
        // Attempt to reset if possible, otherwise just nullify
        if (typeof window.grecaptcha.reset === 'function') {
          window.grecaptcha.reset();
        }
      } catch (e) {
        // Ignore errors during reset attempt
      }
      window.grecaptcha = undefined;
    }

    // Cleanup function for component unmount (optional but good practice)
    return () => {
      // Potentially add cleanup if needed when navigating away from SSOLogin
    };
  }, []); // Empty dependency array ensures this runs only once on mount

  const handleSuccess = async (credentialResponse) => {
    setIsLoading(true);
    setError(null);
    
    try {
      const decodedToken = jwtDecode(credentialResponse.credential);
      const email = decodedToken.email;

      const response = await axios.post(
        "https://icttestalarm.com:3000/api/sso-login-employee",
        { email }
      );

      if (response.data?.message === "SSO login successful") {
        const { role, email, user_id } = response.data.user;
        
        // Store all user data
        localStorage.setItem("userRole", role);
        localStorage.setItem("userEmail", email);
        localStorage.setItem("userId", user_id); // User ID is stored with the key "userId"
        
        // Update parent state
        setUserRole(role);
        
        // Navigate to overview
        navigate("/overview", { 
          replace: true,
          state: {
            role,
            email,
            userId: user_id
          }
        });
      }
    } catch (error) {
      console.error("SSO Error:", error);
      setError(error.response?.data?.message || "Login failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column'
    }}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID_AUTH}>
        {isLoading ? (
          <div style={{ margin: '20px' }}>
            <p>Authenticating...</p>
          </div>
        ) : (
          <>
            {error && (
              <div style={{
                color: 'red',
                marginBottom: '20px',
                padding: '10px',
                border: '1px solid red',
                borderRadius: '4px'
              }}>
                {error}
              </div>
            )}
            <GoogleLogin
              onSuccess={handleSuccess}
              onError={() => setError("Google authentication failed")}
              theme="filled_blue"
              size="large"
            />
          </>
        )}
      </GoogleOAuthProvider>
    </div>
  );
};

export default SSOLogin;